((document, Drupal) => {
  "use strict";
  Drupal.behaviors.internalNavigation = {
    attach: (context) => {
      if (context === document) {
        if (!context.querySelector('.interior-navigation')) {
          return;
        }
        const interiorNavsMobile = context.querySelectorAll('.interior-navigation.mobile');
        interiorNavsMobile.forEach(interiorNav => {
          
          const toggleButton = interiorNav.querySelector('.interior-navigation__toggle');
          const submenu = interiorNav.querySelector('.interior-navigation__items');
          
          toggleButton.addEventListener('click', (e) => {
            console.log('click');
            if (submenu.classList.contains('hidden')) {
              submenu.classList.remove('hidden');
            } else {
              submenu.classList.add('hidden');
            }
          })
        });


      }
    }
  }
})(document, Drupal);